// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { TravelExpenses } from '../Classes/TravelExpenses';
export class TravelExpensesCollection extends Array<TravelExpenses> {
}
